var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "16x16/Add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2175,4.1300475 L4.69,9.6575475 L4.69,11.3901675 L6.42262,11.3901675 L11.95012,5.8626675 L10.2175,4.1300475 Z M11.16488,3.1826675 L12.8975,4.9152875 L13.79262,4.0201675 L12.06,2.2875475 L11.16488,3.1826675 Z M12.53369,0.8664775 L15.21369,3.5464775 C15.47566,3.8077775 15.47566,4.2325575 15.21369,4.4938575 L7.17369,12.5338575 C7.0484,12.6598175 6.87755,12.7301675 6.7,12.7301675 L4.02,12.7301675 C3.65016,12.7301675 3.35,12.4300075 3.35,12.0601675 L3.35,9.3801675 C3.35,9.2026175 3.42035,9.0317675 3.54631,8.9064775 L11.58631,0.8664775 C11.84761,0.6045075 12.27239,0.6045075 12.53369,0.8664775 Z M2.01,14.0701675 L13.4,14.0701675 L13.4,8.7101675 C13.4,8.3403275 13.70016,8.0401675 14.07,8.0401675 C14.43984,8.0401675 14.74,8.3403275 14.74,8.7101675 L14.74,14.7401675 C14.74,15.1100075 14.43984,15.4101675 14.07,15.4101675 L1.34,15.4101675 C0.97016,15.4101675 0.67,15.1100075 0.67,14.7401675 L0.67,2.0101675 C0.67,1.6403275 0.97016,1.3401675 1.34,1.3401675 L7.37,1.3401675 C7.73984,1.3401675 8.04,1.6403275 8.04,2.0101675 C8.04,2.3800075 7.73984,2.6801675 7.37,2.6801675 L2.01,2.6801675 L2.01,14.0701675 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.4-\\u2014-Company-\\xB7-Uipath-Contacts-\\xB7-Admin",
    transform: "translate(-1239.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company-Feature",
    transform: "translate(360.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogoCompany---Small",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EditProfile",
    transform: "translate(675.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Edit2",
    transform: "translate(188.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.69f178aaf74263a31407a79f31650f49.svg";
export { ForwardRef as ReactComponent };